var DocumentsTreeController = /** @class */ (function () {
    /*@ngInject*/
    function DocumentsTreeController($scope, $rootScope, $timeout, alertsAndNotificationsService, StorageService, MESSAGECONSTANTS) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.StorageService = StorageService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    DocumentsTreeController.prototype.$onInit = function () {
        this.isJobMatchDocumentsAvailable = false;
        this.isCandidateDocumentsAvailable = false;
        this.onDataChangeCount = 1;
        this._setDocumentTreeFolderVisibility();
        this._setCandidateDocuments();
    };
    DocumentsTreeController.prototype.$onChanges = function (changes) {
        var _this = this;
        if (changes && changes.folders && this.onDataChangeCount > 0) {
            this.$timeout(function () {
                _this._setDocumentTreeFolderVisibility();
                _this._setCandidateDocuments();
            }, 100);
            this.onDataChangeCount += 1;
        }
    };
    DocumentsTreeController.prototype._setCandidateDocuments = function () {
        var _this = this;
        if (this.availableDocumentsInFolders && this.availableDocumentsInFolders.length > 0) {
            this.availableDocumentsInFolders.every(function (document) {
                if (!document.isJobMatchDocument) {
                    _this.isCandidateDocumentsAvailable = true;
                    return false;
                }
                return true;
            });
        }
    };
    DocumentsTreeController.prototype._setDocumentTreeFolderVisibility = function () {
        var _this = this;
        if (this.folders.length > 0) {
            this.folders.map(function (parentFolder) {
                if (parentFolder.documents.length > 0) {
                    parentFolder.showParentFolder = true;
                    _this.isJobMatchDocumentsAvailable = true;
                }
                else {
                    parentFolder.showParentFolder = false;
                }
                parentFolder.showActions = false;
                if (parentFolder.folders && parentFolder.folders.length > 0) {
                    parentFolder.folders.map(function (childFolder) {
                        childFolder.showChildFolder = childFolder.documents.length > 0 ? true : false;
                        childFolder.showActions = false;
                        if (childFolder.showChildFolder) {
                            parentFolder.showParentFolder = true;
                        }
                    });
                }
            });
        }
    };
    DocumentsTreeController.prototype.remove = function (scope) {
        scope.remove();
    };
    DocumentsTreeController.prototype.toggle = function (scope) {
        scope.toggle();
    };
    DocumentsTreeController.prototype.moveLastToTheBeginning = function () {
        var a = this.data.pop();
        this.data.splice(0, 0, a);
    };
    DocumentsTreeController.prototype.collapseAll = function () {
        this.$scope.$broadcast('angular-ui-tree:collapse-all');
    };
    DocumentsTreeController.prototype.expandAll = function () {
        this.$scope.$broadcast('angular-ui-tree:expand-all');
    };
    DocumentsTreeController.prototype.onChangeViewType = function (viewType) {
        this.showList = viewType == 'list';
    };
    DocumentsTreeController.prototype.visible = function (item) {
        return !(this.query && this.query.length > 0
            && item.title.indexOf(this.query) == -1);
    };
    DocumentsTreeController.prototype.findNodes = function () {
    };
    DocumentsTreeController.prototype.selectFolder = function (folder, type) {
        if (type != 'fromDocumentSelect') {
            this._resetSelectedCandidateDocuments();
        }
        folder.isJobMatchFolders = this.isJobMatchFolders;
        if (this.onSelectFolder) {
            this.onSelectFolder({ selectedFolder: folder });
        }
    };
    DocumentsTreeController.prototype.addFolder = function (folder) {
        if (this.onAddFolder) {
            this.onAddFolder({ parentFolder: folder });
        }
    };
    DocumentsTreeController.prototype.editFolder = function (folder) {
        if (this.onEditFolder) {
            this.onEditFolder({ folder: folder });
        }
    };
    DocumentsTreeController.prototype.deleteFolder = function (folder) {
        if (this.onDeleteFolder) {
            this.onDeleteFolder({ folder: folder });
        }
    };
    DocumentsTreeController.prototype.moveFolder = function (folder) {
        if (this.onMoveFolder) {
            this.onMoveFolder({ folder: folder });
        }
    };
    DocumentsTreeController.prototype.selectFolderWithDocuments = function (folder) {
        folder.isJobMatchFolders = this.isJobMatchFolders;
        if (this.onSelectFolderWithDocuments) {
            this.onSelectFolderWithDocuments({ folder: folder });
        }
    };
    DocumentsTreeController.prototype.selectAndDeselectDocument = function (document, folder) {
        if (this.onSelectAndDeselectDocument) {
            this.onSelectAndDeselectDocument({ document: document, folder: folder });
        }
    };
    DocumentsTreeController.prototype._resetSelectedCandidateDocuments = function () {
        if (this.folders.length > 0) {
            this.folders.map(function (parentFolder) {
                if (parentFolder.documents.length > 0) {
                    parentFolder.documents.map(function (doc) {
                        doc.isDocumentSelected = false;
                    });
                }
                if (parentFolder.folders && parentFolder.folders.length > 0) {
                    parentFolder.folders.map(function (childFolder) {
                        if (childFolder.documents.length > 0) {
                            childFolder.documents.map(function (doc) {
                                doc.isDocumentSelected = false;
                            });
                        }
                    });
                }
            });
        }
    };
    DocumentsTreeController.prototype.onDocumentSelect = function (document, folder) {
        if (!this.isAvailableDocuments) {
            this._resetSelectedCandidateDocuments();
            document.isDocumentSelected = true;
            this.selectFolder(folder, 'fromDocumentSelect');
        }
    };
    return DocumentsTreeController;
}());
DocumentsTreeController.$inject = ['$scope', '$rootScope', '$timeout', 'alertsAndNotificationsService', 'StorageService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './documents-tree.html';
import * as TEMPLATE from 'raw-loader!./documents-tree.html';
export var DocumentsTreeComponent = {
    selector: 'documentsTree',
    component: {
        bindings: {
            folders: "<",
            isJobMatchFolders: "<",
            isAvailableDocuments: '<',
            availableDocumentsInFolders: '<',
            customStyle: '@',
            onSelectFolder: "&",
            onAddFolder: "&",
            onEditFolder: "&",
            onDeleteFolder: "&",
            onMoveFolder: "&",
            onSelectFolderWithDocuments: "&",
            onSelectAndDeselectDocument: '&'
        },
        controller: DocumentsTreeController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/documentsTree/documents-tree.html'
    }
};
//# sourceMappingURL=documents-tree.component.js.map